import React from 'react';
import PropTypes from 'prop-types';

const BookingWidget = ({ workspaceName, widgetId, widgetDomain }) => {
  const src = `https://widget.${widgetDomain}/${workspaceName}/book-online/${widgetId}`;
  return (
    <>
      <iframe
        title="bookteq-widget"
        src={src}
        style={{ width: '100%', minHeight: '850px', border: 0 }}
        sandbox="allow-forms allow-scripts allow-downloads allow-same-origin"
      />
    </>
  );
};

BookingWidget.propTypes = {
  workspaceName: PropTypes.string.isRequired,
  widgetId: PropTypes.string.isRequired,
  widgetDomain: PropTypes.string.isRequired,
};

export default BookingWidget;
